import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["appointment"];

  select(event) {
    this.appointmentTargets.forEach((target) => {
      target.classList.remove("bg-lighter");
    });

    event.currentTarget
      .closest('[data-dispatch-appointments-target="appointment"]')
      .classList.add("bg-lighter");
  }

  deselect() {
    this.appointmentTargets.forEach((target) => {
      target.classList.remove("bg-lighter");
    });
  }
}
